import { queryOptions } from '@tanstack/react-query';

import { ICountry } from '@/resources/upgrade/Country';
import { apiClient } from '@/resources/upgrade/jsonapi-client';

// NOTE: `enabled` only guards useQuery — queryClient.prefetchQuery ignores it,
// so SSR callers must check countryId themselves before prefetching
export function countryQueryOptions(countryId: string | undefined) {
  return queryOptions({
    queryKey: ['countries', countryId],
    queryFn: async () => {
      const country = await apiClient.get<ICountry>(`countries/${countryId}`);

      return country;
    },
    enabled: Boolean(countryId),
    staleTime: 1000 * 60 * 5,
  });
}
